import { memo } from 'react';
import { useIntl } from 'react-intl';
import { PaginationTopAnchor } from '../../../core/components/Pagination';
import ProductList from '../ProductList/List/ProductList';
import withErrorBoundary from '../../../core/components/errors/withErrorBoundary';
import ProductListTireSearch, {
    useTireSearchEnabled,
} from '../TireSearchNew/ProductListTireSearch';
import { tireFiltersIgnoreList } from '../TireSearchNew';
import useCurrentStore from '../../../core/hooks/useCurrentStore';
import useCategory from '../../../core/queries/useCategory';
import PageNotFound from '../../../core/components/router/PageNotFound';

const CategoryProductsList = () => {
    const { enabled } = useTireSearchEnabled();
    const intl = useIntl();
    const { categoryName, notFound } = useCategory();
    const { companyName } = useCurrentStore();

    const categoryTitle = intl.formatMessage(
        {
            id: 'Category ProductListPage Title',
        },
        { categoryName }
    );
    const title = `${categoryTitle} ${companyName}`;

    if (notFound) {
        return <PageNotFound />;
    }

    return (
        <>
            {!enabled && <PaginationTopAnchor />}
            <ProductList
                title={title}
                ignoreList={
                    enabled ? ['bicycleId', ...tireFiltersIgnoreList] : []
                }
                banner={
                    <>
                        <ProductListTireSearch />
                        {enabled && <PaginationTopAnchor />}
                    </>
                }
                singleRootCategory
                showEmptyCategories
            />
        </>
    );
};

export default memo(withErrorBoundary(CategoryProductsList));
